import { pipelineEntries, pipelineFixtures } from './pipeline-entries';
import { integrationEntries, integrationFixtures } from './integration-entries';
import { pipelineIntegrationEntries, pipelineIntegrationFixtures } from './pipeline-integration-entries';
import { pipelineEventEntries, pipelineEventFixtures } from './pipeline-event-entries';
import { schemaEntries, schemaFixtures } from './schema-entries';
import { schemaLibraryEntries, schemaLibraryFixtures } from './schema-library-entries';
import { pipelineSchemaLibraryEntries, pipelineSchemaLibraryFixtures } from './pipeline-schema-library-entries';
import { eventNameEntries, eventNameFixtures } from './event-name-entries';
import { eventSchemaEntries, eventSchemaFixtures } from './event-schema-entries';
import { sampleEventEntries, sampleEventFixtures } from './sample-event-entries';
import { tagEntries, tagFixtures } from './tag-entries';
import { pipelineTagEntries, pipelineTagFixtures } from './pipeline-tag-entries';
import { consentCategoryEntries, consentCategoryFixtures } from './consent-category-entries';
import { playbookEntries, playbookFixtures } from './playbook-entries';
import { stagedRevisionEntries, stagedRevisionFixtures } from './staged-revision-entries';
import { userEntries, userFixtures } from './user-entries';
import { authEntries, authFixtures } from './auth-entries';
import { metataggerEntries, metataggerFixtures } from './metatagger-entries';

export const coreEntries = {
  ...pipelineEntries,
  ...integrationEntries,
  ...pipelineIntegrationEntries,
  ...pipelineEventEntries,
  ...schemaEntries,
  ...schemaLibraryEntries,
  ...pipelineSchemaLibraryEntries,
  ...eventNameEntries,
  ...eventSchemaEntries,
  ...sampleEventEntries,
  ...tagEntries,
  ...pipelineTagEntries,
  ...consentCategoryEntries,
  ...playbookEntries,
  ...stagedRevisionEntries,
  ...userEntries,
  ...authEntries,
  ...metataggerEntries,
};

export const coreFixtures = {
  ...pipelineFixtures,
  ...integrationFixtures,
  ...pipelineIntegrationFixtures,
  ...pipelineEventFixtures,
  ...schemaFixtures,
  ...schemaLibraryFixtures,
  ...pipelineSchemaLibraryFixtures,
  ...eventNameFixtures,
  ...eventSchemaFixtures,
  ...sampleEventFixtures,
  ...tagFixtures,
  ...pipelineTagFixtures,
  ...consentCategoryFixtures,
  ...playbookFixtures,
  ...stagedRevisionFixtures,
  ...userFixtures,
  ...authFixtures,
  ...metataggerFixtures,
};
